module.exports = __webpack_public_path__ + "img/pictures2.09995522.png";